import React from 'react';
import classnames from 'classnames';

import './placeholder.scss';

const defaultBoxStyles = {height: '60px', border: '1px solid #d3d3d3', background: 'white', marginBottom: '20px', padding: '15px'};
export function Box({ children, style }) {
	return (<div style={Object.assign( {}, defaultBoxStyles, style )}>
		{children}
	</div>);
}

export function PlaceholderSpan({ height, width = '100%', className, style = {} }) {
	return (<span className={classnames('loads', className)} style={{ width, height, ...style }}></span>);
}

export default function Placeholder({ height, width = '100%', className, style = {} }) {
	return (<div className={classnames('loads', className)} style={{ width, height, ...style }}></div>);
}

export function ListPlaceHolder({ hasTitle = true, hasIcon = false, filtersNumber = 0, style = {} }) {
	return (
		<div className="container" style={{ ...style }}>
			{hasTitle &&
				<div className="container__header">
					<div className="list-title-loader loads" />
				</div>
			}
			<div className="container__body">
				{filtersNumber > 0 &&
					<div className="list-filters-loader" style={{ gridTemplateColumns: `repeat(${filtersNumber}, 1fr)` }}>
						{Array(filtersNumber).fill().map((e, i) => (
							<Placeholder key={`placeholder-filter-${i}`} />
						))}
					</div>
				}
				<div className="list-body-loader">
					<div className={classnames('list-row-loader', hasIcon && 'icon-row')}>
						{hasIcon && <div className="list-item-icon-loader loads" />}
						<Placeholder className="list-item-loader" />
					</div>
					<div className={classnames('list-row-loader', hasIcon && 'icon-row')}>
						{hasIcon && <div className="list-item-icon-loader loads" />}
						<Placeholder className="list-item-loader" />
					</div>
				</div>
			</div>
		</div>
	);
}